import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { editProfilePictureActions } from './edit-profile-picture.actions';
import { map } from 'rxjs/operators';
import { profileApiActions } from '@fitup-monorepo/core/lib/state/profile/profile.actions';

@Injectable()
export class EditProfilePictureEffects {
  private readonly actions$ = inject(Actions);

  public uploadImage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editProfilePictureActions.uploadImage),
      map(props => profileApiActions.uploadImage(props))
    )
  );

  public setAvatar$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editProfilePictureActions.setAvatar),
      map(props => profileApiActions.setAvatar(props))
    )
  );

  public deleteImage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editProfilePictureActions.deleteImage),
      map(props => profileApiActions.deleteImage())
    )
  );
}
